import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, {
    KTBSButtonColor,
    KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import StringUtils from 'general/utils/StringUtils';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const CustomDropdown3Directions = {
    left: 'dropleft',
    up: 'dropup',
    right: 'dropright',
    down: 'dropdown',
};

export const CustomDropdown3Alignments = {
    start: 'dropdown-menu-start',
    end: 'dropdown-menu-end',
};

export const KTBSDropdowAutoCloseBehavior = {
    true: 'true',
    false: 'false',
    inside: 'inside',
    outside: 'outside',
};

CustomDropdown3.propTypes = {
    name: PropTypes.string,
    toggleWrapperClassName: PropTypes.string,
    toggleElement: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
    dropdownMenuClassName: PropTypes.string,
    dropdownMenuStyle: PropTypes.object,
    dropdownMenuItems: PropTypes.array,
    selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    direction: PropTypes.oneOf(Object.values(CustomDropdown3Directions)),
    alignment: PropTypes.oneOf(Object.values(CustomDropdown3Alignments)),
    offset: PropTypes.object,
    staticDisplay: PropTypes.bool,
    autoCloseBehavior: PropTypes.oneOf(Object.values(KTBSDropdowAutoCloseBehavior)),
    contentEl: PropTypes.element,
    onChange: PropTypes.func,
    text: PropTypes.string,

    enableCheckValid: PropTypes.bool,
    isTouched: PropTypes.bool,
    isValid: PropTypes.bool,
    feedbackText: PropTypes.string,

    searchable: PropTypes.bool,
    titleSearchable: PropTypes.bool,
    footerEl: PropTypes.element,

    inputCheckbox: PropTypes.func,
    handleItemClick: PropTypes.func,

    disabled: PropTypes.bool,
    isDropdownForm: PropTypes.bool,
    id: PropTypes.string,

    liveSearch: PropTypes.bool,
    onTextChanged: PropTypes.func,
    defaultValue: PropTypes.object,
    defaultItem: PropTypes.object,
    appendText: PropTypes.string,
    ignoreConfirmClick: PropTypes.bool,
    subTitleType: PropTypes.string,
    defaultTitle: PropTypes.string,
    defaultShowThirdLevel: PropTypes.bool,
};

CustomDropdown3.defaultProps = {
    name: '',
    toggleWrapperClassName: '',
    toggleElement: <></>,
    dropdownMenuClassName: '',
    dropdownMenuStyle: {},
    dropdownMenuItems: [],
    selectedValue: null,
    direction: CustomDropdown3Directions.down,
    alignment: CustomDropdown3Alignments.start,
    offset: null,
    staticDisplay: true,
    autoCloseBehavior: KTBSDropdowAutoCloseBehavior.true,
    contentEl: null,
    onChange: null,
    text: '',

    enableCheckValid: false,
    isValid: true,
    isTouched: false,
    feedbackText: '',
    searchable: false,
    titleSearchable: false,
    footerEl: null,
    inputCheckbox: null,
    handleItemClick: null,
    disabled: false,
    isDropdownForm: false,
    id: '',
    liveSearch: false,
    onTextChanged: null,
    defaultValue: {},
    defaultItem: {},
    appendText: '',
    ignoreConfirmClick: false,
    subTitleType: '',
    defaultTitle: '',
    defaultShowThirdLevel: false,
};

/**
 *
 * @param {{
 * name: string,
 * toggleWrapperClassName: string,
 * toggleElement: element|function,
 * dropdownMenuClassName: string,
 * dropdownMenuStyle: object,
 * dropdownMenuItems: object[],
 * selectedValue: string|number|object,
 * direction: string,
 * alignment: string,
 * offset: {},
 * staticDisplay: boolean,
 * autoCloseBehavior: boolean,
 * contentEl: element,
 * onChange: function,
 * text: string,
 *
 * enableCheckValid: boolean,
 * isValid: boolean,
 * isTouched: boolean,
 * feedbackText: string,
 *
 * searchable: boolean,
 * titleSearchable: boolean,
 * footerEl: element,
 * inputCheckbox:func,
 * handleItemClick:func,
 * disabled:boolean,
 * isDropdownForm:boolean,
 * id: string,
 *
 * liveSearch: boolean,
 * onTextChanged: function,
 * defaultValue: object,
 * defaultItem: object,
 * appendText: string,
 * ignoreConfirmClick: boolean,
 * subTitleType: string,
 * defaultTitle: string,
 * defaultShowThirdLevel: boolean,
 *
 * }} props
 * @returns
 */
function CustomDropdown3(props) {
    const {
        name,
        toggleWrapperClassName,
        toggleElement,
        dropdownMenuClassName,
        dropdownMenuStyle,
        dropdownMenuItems,
        selectedValue,
        direction,
        alignment,
        offset,
        staticDisplay,
        autoCloseBehavior,
        contentEl,
        onChange,
        text,
        enableCheckValid,
        isValid,
        isTouched,
        feedbackText,
        searchable,
        titleSearchable,
        footerEl,
        inputCheckbox,
        handleItemClick,
        disabled,
        isDropdownForm,
        searchFormClassName,
        isOpen,
        id,
        liveSearch,
        onTextChanged,
        getSubItems,
        defaultValue,
        defaultItem,
        appendText,
        ignoreConfirmClick,
        subTitleType,
        dependItem,
        defaultTitle,
        secondLevelTitle,
        thirdLevelTitle,
        defaultShowThirdLevel,
        defaultShowType = 'productType'
    } = props;

    const currentSelectedValue = useRef(selectedValue);
    const showError = enableCheckValid && !isValid && isTouched && !_.isEmpty(feedbackText);
    const [showSubItem, setShowSubItem] = useState(!!selectedValue?.[defaultShowType]);
    const [showThirdLevel, setShowThirdLevel] = useState(defaultShowThirdLevel ?? false);
    const currentSelectedItem = useRef(null);
    const currentThirdLevelItem = useRef(null);
    const productTypeRef = useRef(selectedValue?.[defaultShowType] || '');

    const [searchText, setSearchText] = useState('');
    const [searchTitleText, setSearchTitleText] = useState('');
    const { t } = useTranslation();
    const [filteredDropdownMenuItems, setFilteredDropdownMenuItems] = useState([]);
    const [filteredDropdownTitle, setFilteredDropdownTitle] = useState([]);
    const [filteredThirdLevelItems, setFilteredThirdLevelItems] = useState([]);
    const [updateTrigger, setUpdateTrigger] = useState(0);
    useEffect(() => {
        if (defaultShowThirdLevel) {
            setShowThirdLevel(defaultShowThirdLevel);
        }
    }, [defaultShowThirdLevel])

    useEffect(() => {
        let filteredOptions = dropdownMenuItems || [];
        if (titleSearchable && searchTitleText) {
            filteredOptions = _.filter(dropdownMenuItems, (item) => {
                const itemName = StringUtils.removeVietnameseTones(item?.name ?? '').toLowerCase();
                return itemName?.includes(
                    StringUtils.removeVietnameseTones(searchTitleText ?? '').toLowerCase()
                );
            });
        }
        setFilteredDropdownTitle(filteredOptions);
    }, [searchTitleText, dropdownMenuItems]);

    useEffect(() => {
        currentSelectedValue.current = selectedValue;
        productTypeRef.current = selectedValue?.[defaultShowType] || '';
        setShowSubItem(!!selectedValue?.[defaultShowType]);
    }, [selectedValue]);
    useEffect(() => {
        if (
            currentSelectedItem.current &&
            defaultItem?.role &&
            currentSelectedItem.current.role === defaultItem?.role
        ) {
            if (!searchText?.length) {
                if (
                    !currentSelectedItem.current.subItems?.some(
                        (item) => JSON.stringify(item) === JSON.stringify(defaultItem?.item)
                    )
                ) {
                    currentSelectedItem.current = {
                        ...currentSelectedItem.current,
                        subItems: [defaultItem?.item, ...(currentSelectedItem.current.subItems || [])].filter(
                            Boolean
                        ),
                    };
                }
            } else {
                const itemName = StringUtils.removeVietnameseTones(
                    defaultItem?.item?.name ?? ''
                ).toLowerCase();
                if (
                    itemName?.includes(StringUtils.removeVietnameseTones(searchText ?? '').toLowerCase()) &&
                    !currentSelectedItem.current.subItemsSearch?.some(
                        (item) => JSON.stringify(item) === JSON.stringify(defaultItem?.item)
                    )
                ) {
                    currentSelectedItem.current = {
                        ...currentSelectedItem.current,
                        subItemsSearch: [
                            defaultItem?.item,
                            ...(currentSelectedItem.current.subItemsSearch || []),
                        ].filter(Boolean),
                    };
                }
            }
            setFilteredDropdownMenuItems(
                searchText?.length
                    ? currentSelectedItem.current?.subItemsSearch || []
                    : currentSelectedItem.current?.subItems || []
            );
        }
    }, [defaultItem, searchText]);

    useEffect(() => {
        const filteredOptions = searchText?.length
            ? currentSelectedItem.current?.subItemsSearch || []
            : currentSelectedItem.current?.subItems || [];
        setFilteredDropdownMenuItems(filteredOptions);
    }, [searchText, updateTrigger, currentSelectedItem.current?.subItems]);

    useEffect(() => {
        const filteredOptions = searchText?.length
            ? currentThirdLevelItem.current?.subItemsSearch || []
            : currentThirdLevelItem.current?.subItems || [];
        setFilteredThirdLevelItems(filteredOptions);
    }, [searchText, updateTrigger, currentThirdLevelItem.current?.subItems]);

    const handleToggleClick = () => {
        currentSelectedValue.current = selectedValue;
        setPage(1);
        setSearchText('');
        setShowSubItem(!!selectedValue?.[defaultShowType]);
    };

    const listRef = useRef(null);
    const isFetching = useRef(false);
    const [page, setPage] = useState(1);
    const lastScrollTop = useRef(0);

    const handleScroll = () => {
        if (!listRef.current || isFetching.current) return;

        const { scrollTop, scrollHeight, clientHeight } = listRef.current;

        if (scrollTop + clientHeight >= scrollHeight - 2) {
            const currentLength = searchText?.length
                ? showThirdLevel
                    ? currentThirdLevelItem.current?.subItemsSearch?.length || 0
                    : currentSelectedItem.current?.subItemsSearch?.length || 0
                : showThirdLevel
                    ? currentThirdLevelItem.current?.subItems?.length || 0
                    : currentSelectedItem.current?.subItems?.length || 0;
            const total = searchText?.length
                ? showThirdLevel
                    ? currentThirdLevelItem.current?.subItemsSearchTotal || 0
                    : currentSelectedItem.current?.subItemsSearchTotal || 0
                : showThirdLevel
                    ? currentThirdLevelItem.current?.subItemsTotal || 0
                    : currentSelectedItem.current?.subItemsTotal || 0;

            if (currentLength < total) {
                isFetching.current = true;
                setPage((prev) => prev + 1);
                const currentItem = showThirdLevel ? currentThirdLevelItem.current : currentSelectedItem.current;
                getSubItems?.({ ...currentItem, page, q: searchText })
                    .then((result) => {
                        if (result && result.values && typeof result.total !== 'undefined') {
                            const { values, total } = result;
                            if (showThirdLevel) {
                                currentThirdLevelItem.current = {
                                    ...currentThirdLevelItem.current,
                                    subItems: !searchText?.length
                                        ? [...(currentThirdLevelItem.current?.subItems || []), ...values]
                                        : currentThirdLevelItem.current?.subItems || [],
                                    subItemsSearch: searchText?.length
                                        ? [...(currentThirdLevelItem.current?.subItemsSearch || []), ...values]
                                        : currentThirdLevelItem.current?.subItemsSearch || [],
                                    subItemsTotal: total,
                                    subItemsSearchTotal: searchText?.length
                                        ? total
                                        : currentThirdLevelItem.current?.subItemsSearchTotal,
                                };
                                setFilteredThirdLevelItems(
                                    searchText?.length
                                        ? currentThirdLevelItem.current?.subItemsSearch
                                        : currentThirdLevelItem.current?.subItems
                                );
                            } else {
                                currentSelectedItem.current = {
                                    ...currentSelectedItem.current,
                                    subItems: !searchText?.length
                                        ? [...(currentSelectedItem.current?.subItems || []), ...values]
                                        : currentSelectedItem.current?.subItems || [],
                                    subItemsSearch: searchText?.length
                                        ? [...(currentSelectedItem.current?.subItemsSearch || []), ...values]
                                        : currentSelectedItem.current?.subItemsSearch || [],
                                    subItemsTotal: total,
                                    subItemsSearchTotal: searchText?.length
                                        ? total
                                        : currentSelectedItem.current?.subItemsSearchTotal,
                                };
                                setFilteredDropdownMenuItems(
                                    searchText?.length
                                        ? currentSelectedItem.current?.subItemsSearch
                                        : currentSelectedItem.current?.subItems
                                );
                            }
                            setUpdateTrigger((prev) => prev + 1);
                            isFetching.current = false;
                        } else {
                            isFetching.current = false;
                        }
                    })
                    .catch((error) => {
                        console.error('Error fetching subitems:', error);
                        isFetching.current = false;
                    });
            }
        }

        lastScrollTop.current = scrollTop;
    };

    useEffect(() => {
        const element = listRef.current;
        if (element) {
            element.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (element) {
                element.removeEventListener('scroll', handleScroll);
            }
        };
    }, [searchText, showSubItem, showThirdLevel]);

    useEffect(() => {
        if (defaultValue?.role && getSubItems) {
            getSubItems({ ...defaultValue, page: 0, q: '' })
                .then((result) => {
                    if (result && result.values && typeof result.total !== 'undefined') {
                        const { values, total } = result;
                        currentSelectedItem.current = {
                            ...defaultValue,
                            subItems: values,
                            subItemsTotal: total,
                        };
                        setFilteredDropdownMenuItems(values);
                        setShowSubItem(true);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching default subitems:', error);
                });
        }
    }, [defaultValue?.role, getSubItems]);

    const renderDropdownMenuItems = useMemo(() => {
        const items = showThirdLevel ? filteredThirdLevelItems : filteredDropdownMenuItems;
        if (items.length > 0) {
            return (
                <>
                    {items.map((item, index) => {
                        return (
                            <div key={index}>
                                {inputCheckbox ? (
                                    <div className="d-flex align-items-center ml-7">
                                        {inputCheckbox(item)}
                                        <a
                                            className={`dropdown-item 
                        ${currentSelectedValue.current?.id &&
                                                    currentSelectedValue.current?.id === item?.id
                                                    ? 'active'
                                                    : ''
                                                } px-5`}
                                            style={{ paddingLeft: 'unset' }}
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleItemClick(item);
                                            }}
                                        >
                                            {item.name}
                                        </a>
                                    </div>
                                ) : (
                                    <a
                                        className={`d-flex align-items-center justify-content-between dropdown-item 
                      ${currentSelectedValue.current?.id &&
                                                currentSelectedValue.current?.id === item?.id
                                                ? 'active'
                                                : ''
                                            } px-5`}
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            if (showSubItem && item?.hasThirdLevel) {
                                                setPage(1);
                                                setSearchText('');
                                                currentThirdLevelItem.current = { ...item };
                                                getSubItems?.({ ...item, page: 0, q: '' })
                                                    .then((result) => {
                                                        if (result && result.values && typeof result.total !== 'undefined') {
                                                            const { values, total } = result;
                                                            currentThirdLevelItem.current = {
                                                                ...item,
                                                                subItems: values,
                                                                subItemsTotal: total,
                                                            };
                                                            setFilteredThirdLevelItems(values);
                                                            setShowThirdLevel(true);
                                                        }
                                                    })
                                                    .catch((error) => {
                                                        console.error('Error fetching third level items:', error);
                                                    });
                                            } else {
                                                currentSelectedValue.current = item;
                                                onChange?.(currentSelectedValue.current);
                                                handleCloseDropdown();
                                            }
                                        }}
                                    >
                                        <div className="d-flex flex-column">
                                            <span style={{ whiteSpace: 'break-spaces' }}>{item.name}</span>
                                            {!!subTitleType && item?.[subTitleType] && (
                                                <span
                                                    style={{
                                                        fontWeight: '400',
                                                        fontSize: '14px',
                                                        color: AppColors.gray[600],
                                                        whiteSpace: 'break-spaces',
                                                    }}
                                                >
                                                    {item[subTitleType]}
                                                </span>
                                            )}
                                        </div>
                                        {showSubItem && item?.hasThirdLevel && !showThirdLevel ? (
                                            <i className="far fa-angle-right text-success" />
                                        ) : (
                                            currentSelectedValue.current?.id &&
                                            currentSelectedValue.current?.id === item.id && (
                                                <i className="fa-regular fa-check text-success" />
                                            )
                                        )}
                                    </a>
                                )}
                                {item.showDivider && <div className="dropdown-divider" />}
                            </div>
                        );
                    })}
                    {!ignoreConfirmClick && !showThirdLevel && (
                        <div
                            className="py-2 px-4 d-flex justify-content-end"
                            style={{
                                position: 'sticky',
                                bottom: 0,
                                background: 'white',
                                zIndex: 10,
                                width: '100%',
                            }}
                        >
                            <KTBSButton
                                color={KTBSButtonColor.success}
                                title={t('Lưu')}
                                size={KTBSButtonSize.large}
                                borderRadius={5}
                                buttonTitleFontWeight="600"
                                onPress={() => onChange?.(currentSelectedValue.current)}
                                additionalClassName="col-2"
                            />
                        </div>
                    )}
                </>
            );
        }

        return (
            <div className="mx-auto">
                <div className="d-flex flex-column align-items-center justify-content-center gap-4 h-100 py-3">
                    <img src={imgEmptyNoData} style={{ maxWidth: '150px', maxHeight: '150px' }} />
                    <div className="d-flex flex-column align-items-center gap-2">
                        <span
                            style={{
                                fontWeight: '700',
                                fontSize: Utils.convertToFontSize(14),
                                color: AppColors.gray[800],
                            }}
                        >
                            Chưa có dữ liệu hiển thị
                        </span>
                    </div>
                </div>
            </div>
        );
    }, [
        filteredDropdownMenuItems,
        filteredThirdLevelItems,
        currentSelectedValue.current,
        showSubItem,
        showThirdLevel,
        currentSelectedItem.current,
        inputCheckbox,
        handleItemClick,
        ignoreConfirmClick,
        subTitleType,
        onChange,
        t,
    ]);

    const handleCloseDropdown = () => {
        if (Utils.isValid(id)) {
            $(`#${id}`).dropdown('hide');
        }
    };

    return (
        <div id={`${id}`} className={`${!isDropdownForm ? 'd-flex' : ''}`}>
            <div className={`${direction} w-100 ${disabled && 'dropdown-disabled'}`}>
                {staticDisplay ? (
                    <div
                        className={`${toggleWrapperClassName} ${direction}`}
                        data-bs-toggle="dropdown"
                        data-bs-display="static"
                        aria-expanded="false"
                        data-bs-auto-close={autoCloseBehavior}
                        onClick={handleToggleClick}
                    >
                        {typeof toggleElement === 'function' ? toggleElement({ showError }) : toggleElement}
                    </div>
                ) : (
                    <div
                        className={`${toggleWrapperClassName} ${direction}`}
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        data-bs-auto-close={autoCloseBehavior}
                    >
                        {typeof toggleElement === 'function' ? toggleElement({ showError }) : toggleElement}
                    </div>
                )}

                <div
                    className={`dropdown-menu ${dropdownMenuClassName} ${alignment} py-0`}
                    style={{
                        ...dropdownMenuStyle,
                        display: disabled ? 'none' : '',
                    }}
                    ref={listRef}
                    onScroll={handleScroll}
                >
                    {!showSubItem && !showThirdLevel && (
                        <div className="py-2">
                            {defaultTitle?.length ? (
                                <div
                                    className="py-2 px-4"
                                    style={{ fontWeight: '600', fontSize: '16px', color: AppColors.gray[800] }}
                                >
                                    {defaultTitle}
                                </div>
                            ) : (
                                <></>
                            )}
                            {titleSearchable && (
                                <div className={`${searchFormClassName ? searchFormClassName : 'px-4 py-2'}`}>
                                    <KTFormSearch
                                        name={`${name}_searchbar`}
                                        value={searchTitleText}
                                        placeholder={`${t('TypeToSearch')}...`}
                                        onSubmit={(text) => {
                                            if (!liveSearch) {
                                                setSearchTitleText(text);
                                            } else {
                                                if (onTextChanged) {
                                                    onTextChanged(text);
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            )}
                            {!defaultValue?.role &&
                                filteredDropdownTitle.length > 0 &&
                                filteredDropdownTitle.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            <a
                                                className={`d-flex align-items-center justify-content-between dropdown-item 
                          ${currentSelectedValue.current?.id &&
                                                        currentSelectedValue.current?.id === item?.id
                                                        ? 'active'
                                                        : ''
                                                    } px-5`}
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setPage(1);
                                                    setSearchText('');
                                                    productTypeRef.current = item.value;
                                                    if (getSubItems) {
                                                        currentSelectedItem.current = { ...item };
                                                        getSubItems({ ...item, page: 0, q: '' })
                                                            .then((result) => {
                                                                if (
                                                                    result &&
                                                                    result.values &&
                                                                    typeof result.total !== 'undefined'
                                                                ) {
                                                                    const { values, total } = result;
                                                                    currentSelectedItem.current = {
                                                                        ...item,
                                                                        subItems: values,
                                                                        subItemsTotal: total,
                                                                    };
                                                                    setFilteredDropdownMenuItems(values);
                                                                    setShowSubItem(true);
                                                                    onChange?.({ ...currentSelectedValue.current, [defaultShowType]: item.value });
                                                                }
                                                            })
                                                            .catch((error) => {
                                                                console.error('Error in handling sub items:', error);
                                                            });
                                                    }
                                                }}
                                            >
                                                <div className="d-flex flex-column">
                                                    <span>{item.name}</span>
                                                </div>
                                                <i className="far fa-angle-right text-success" />
                                            </a>
                                        </div>
                                    );
                                })}
                        </div>
                    )}

                    {showSubItem && !showThirdLevel && (
                        <div className="pt-2">
                            <div className="position-sticky top-0 bg-white">
                                <div className="dropdown-header d-flex align-items-center">
                                    <div
                                        style={{ cursor: 'pointer' }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setShowSubItem(false);
                                            setSearchText('');
                                            productTypeRef.current = '';
                                            onChange?.({ ...currentSelectedValue.current, [defaultShowType]: null });
                                        }}
                                    >
                                        <i style={{ color: AppColors.gray[800] }} className="fas fa-arrow-left mr-3"></i>
                                    </div>
                                    {secondLevelTitle && (
                                        <span
                                            style={{
                                                fontSize: Utils.convertToFontSize(16),
                                                fontWeight: '600',
                                                color: AppColors.gray[800],
                                            }}
                                        >
                                            {secondLevelTitle}
                                        </span>
                                    )}
                                </div>
                                {searchable && (
                                    <div className={`${searchFormClassName ? searchFormClassName : 'px-4 py-2'}`}>
                                        <KTFormSearch
                                            name={`${name}_searchbar`}
                                            value={searchText}
                                            placeholder={`${t('TypeToSearch')}...`}
                                            onSubmit={(text) => {
                                                setPage(1);
                                                if (!liveSearch && getSubItems) {
                                                    getSubItems({ ...currentSelectedItem.current, page: 0, q: text })
                                                        .then((result) => {
                                                            if (
                                                                result &&
                                                                result.values &&
                                                                typeof result.total !== 'undefined'
                                                            ) {
                                                                const { values, total } = result;
                                                                currentSelectedItem.current = {
                                                                    ...currentSelectedItem.current,
                                                                    subItemsSearch: values,
                                                                    subItemsSearchTotal: total,
                                                                };
                                                                setSearchText(text);
                                                                setUpdateTrigger((prev) => prev + 1);
                                                            }
                                                        })
                                                        .catch((error) => {
                                                            console.error('Error in handling search sub items:', error);
                                                        });
                                                } else if (onTextChanged) {
                                                    onTextChanged(text);
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                            {!_.isEmpty(contentEl) ? <div>{contentEl}</div> : <div>{renderDropdownMenuItems}</div>}
                            {footerEl && footerEl}
                        </div>
                    )}

                    {showThirdLevel && (
                        <div className="pt-2">
                            <div className="position-sticky top-0 bg-white">
                                <div className="dropdown-header d-flex align-items-center">
                                    <div
                                        style={{ cursor: 'pointer' }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setShowThirdLevel(false);
                                            setSearchText('');
                                        }}
                                    >
                                        <i style={{ color: AppColors.gray[800] }} className="fas fa-arrow-left mr-3"></i>
                                    </div>
                                    {thirdLevelTitle && (
                                        <span
                                            style={{
                                                fontSize: Utils.convertToFontSize(16),
                                                fontWeight: '600',
                                                color: AppColors.gray[800],
                                            }}
                                        >
                                            {thirdLevelTitle}
                                        </span>
                                    )}
                                </div>
                                {searchable && (
                                    <div className={`${searchFormClassName ? searchFormClassName : 'px-4 py-2'}`}>
                                        <KTFormSearch
                                            name={`${name}_searchbar`}
                                            value={searchText}
                                            placeholder={`${t('TypeToSearch')}...`}
                                            onSubmit={(text) => {
                                                setPage(1);
                                                if (!liveSearch && getSubItems) {
                                                    getSubItems({ ...currentThirdLevelItem.current, page: 0, q: text })
                                                        .then((result) => {
                                                            if (
                                                                result &&
                                                                result.values &&
                                                                typeof result.total !== 'undefined'
                                                            ) {
                                                                const { values, total } = result;
                                                                currentThirdLevelItem.current = {
                                                                    ...currentThirdLevelItem.current,
                                                                    subItemsSearch: values,
                                                                    subItemsSearchTotal: total,
                                                                };
                                                                setSearchText(text);
                                                                setUpdateTrigger((prev) => prev + 1);
                                                            }
                                                        })
                                                        .catch((error) => {
                                                            console.error('Error in handling search third level items:', error);
                                                        });
                                                } else if (onTextChanged) {
                                                    onTextChanged(text);
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                            {!_.isEmpty(contentEl) ? <div>{contentEl}</div> : <div>{renderDropdownMenuItems}</div>}
                            {footerEl && footerEl}
                        </div>
                    )}
                </div>
            </div>
            {!_.isEmpty(text) && <span className="form-text text-muted">{text}</span>}
        </div>
    );
}

export default CustomDropdown3;
